import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import MainLayout from "../layouts/MainLayout";
import { storage } from "../common/localStorage";
import { MainLayoutProvider } from "src/layouts/MainLayoutProvider";

const ProtectedRoute = ({ children }) => {
    const isAuthenticated = storage.isAuthenticated();
    return isAuthenticated ? children : <Navigate to="/" />;
  };

const withMainLayout = (WrappedComponent) => {
  return (props) => {
    return (
      <MainLayoutProvider>
        <MainLayout>
            <ProtectedRoute>
                <WrappedComponent {...props} />
            </ProtectedRoute>
        </MainLayout>
      </MainLayoutProvider>
    );
  };
};

export default withMainLayout;
